const white = [255, 255, 255];
const black = [0, 0, 0];

function mix(color, base, weight) {
    return color.map((channel, index) => Math.round(channel * weight + base[index] * (1 - weight)));
}

function luminance(color) {
    const linear = color.map(channel => {
        const value = channel / 255;
        return value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
    });

    return linear[0] * 0.2126 + linear[1] * 0.7152 + linear[2] * 0.0722;
}

function contrast(first, second) {
    const values = [luminance(first), luminance(second)].sort((a, b) => b - a);

    return (values[0] + 0.05) / (values[1] + 0.05);
}

function readableOnLightSurfaces(color, surfaces) {
    for (let amount = 0; amount <= 100; amount++) {
        const candidate = mix(black, color, amount / 100);
        if (surfaces.every(surface => contrast(candidate, surface) >= 4.5)) {
            return candidate;
        }
    }

    return black;
}

function hex(color) {
    return `#${color.map(channel => channel.toString(16).padStart(2, '0')).join('')}`;
}

export function chatTheme(primaryColor) {
    let value = typeof primaryColor === 'string' ? primaryColor.trim() : '';
    if (/^#[\da-f]{3}$/i.test(value)) {
        value = `#${[...value.slice(1)].map(channel => channel.repeat(2)).join('')}`;
    }
    if (!/^#[\da-f]{6}$/i.test(value)) {
        value = '#6A46E4';
    }

    const accent = value.slice(1).match(/../g).map(channel => parseInt(channel, 16));
    const customer = mix(accent, white, 0.06);
    const seller = mix(accent, white, 0.28);
    const assistant = mix(accent, white, 0.03);
    const avatar = mix(accent, white, 0.12);
    const surfaces = [white, customer, seller, assistant, avatar, mix(accent, [250, 250, 250], 0.03)];
    const ink = mix(accent, [16, 16, 22], 0.1);
    const muted = mix(accent, [108, 108, 108], 0.15);

    // WCAG's 4.5:1 minimum applies to names, timestamps and links as well as message text.
    return {
        '--sb-chat-accent': hex(accent),
        '--sb-chat-on-accent': contrast(white, accent) >= contrast(black, accent) ? '#ffffff' : '#000000',
        '--sb-chat-accent-text': hex(readableOnLightSurfaces(accent, surfaces)),
        '--sb-chat-ink': hex(readableOnLightSurfaces(ink, surfaces)),
        '--sb-chat-muted': hex(readableOnLightSurfaces(muted, surfaces)),
        '--sb-chat-customer-bg': hex(customer),
        '--sb-chat-seller-bg': hex(seller),
        '--sb-chat-assistant-bg': hex(assistant),
        '--sb-chat-avatar-bg': hex(avatar),
    };
}
